<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
            <div class="form-section form-section--flex">
            <div class="main-donation">
                <FormSection title="Donation Amount">
                  <FormRow inline>
                      <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/>
            </FormRow> 
                    <div>
                        <AmountSelector/>                    
                        <ErrorLabel field="amount" />
                        <br/>
                        <ShortNote/>                    
                    </div>
                </FormSection>
                <FormSection v-if="form.amount">
                  <TransactionFee />
                </FormSection>
                <FormSection title="Donation Frequency">
                  <DonationFrequency />               
                    </FormSection>
                </div>
                </div>

                <div class="form-section">
                <div class="form-section__inner">
                <FormSection title="Personal Info">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow> 
                    <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow> 
                    <br/>
                    <InHonorOf v-if="form.amount && Number(form.amount) > 8"/>
                </FormSection>                
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                </div>
                </div>
                <div class="form-section">
                  <div class="form-section__inner">
                  <FormSection title="Payment Information" last>
                    <FormRow>
                    <Receipt :receipts="['canadian', 'us']" />
                    <br>
                  </FormRow> 
                      <FormRow inline>
                      <FormCol field="card" :showLabel="false"/>
                      </FormRow>
                  </FormSection>
                  </div>
                 </div>
                <PaymentButton showAmount btnText="make donation"/>
            </PaymentForm>
            <div class="thank-text">
                    Thank you for support of Yachad Summer Programs
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { onMounted } from 'vue'
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const {  getValue, settings, setValue, form, submit } = usePaymentForm()
    const params = queryParams()

    if (props.subCampaign) {
      setValue('applications.0.subCampaign', props.subCampaign)
    }


    onMounted(() => {

      if (params.utm_content) {
        if (
          !['Direct Mail', 'Telemarketing', 'Text SMS Message'].includes(
            params.utm_content
          )
        ) {
          throw new Error('Invalid subcampaign')
        }

        setValue('applications.0.subCampaign', params.utm_content)
      }


      if (params.designation) {
      //@ts-ignore
      switch (params.designation) {     
        case "Chaverim":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Camp Chaverim");
          break;
        case "Amichai":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Camp Amichai");
          break;
        case "Getaway":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Getaway");
          break;
        case "Kesher":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Camp Kesher");
          break;
        case "Lavi":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Camp Lavi");
          break;
        case "Mesorah":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Camp Mesorah");
          break;
        case "Morasha":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Camp Morasha");
          break;
        case "MoshavaAlevy":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Moshava Alevy");
          break;
        case "MoshavaBairNJ":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Moshava Ba'ir NJ (MBNJ)");
          break;
        case "MoshavaBairToronto":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Moshava Ba'ir Toronto (MBT)");
          break;
        case "MoshavaEnnismore":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Moshava IO (Indian Orchard, PA)");
          break;
        case "MoshavaWildRose":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Moshava Wild Rose");
          break;
        case "Nesher":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Camp Nesher");
          break;
        case "Sephardic Adventure Camp":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Sephardic Adventure Camp");
          break;
        case "Yachad BaChutz":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Yachad BaChutz");
          break;
        case "YadBYad":
        setValue("custom.designation", "Summer Programs");
        setValue("custom.subDesignation", "Yad B'Yad (YBY)");
          break;
      }
    }

    })





    return {
      form,
      submit,
      getValue,
      settings,
      setValue,
    }
  },
})
</script>
<style scoped lang="scss">

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.form-container.ou-donation-form{
  margin: 0px auto;
  padding: 0px;
  max-width: 100%;
  background: none;
  box-shadow: none;
}

::v-deep .ou-donation-form{
  label{
    color: black;
    margin-bottom: 0;
    letter-spacing: normal;
    text-transform: none;
    font-size: 13px;
  }

  .styled-radio.styled-radio--ou-donation.row{
    label{
            font-size: 16px !important;
          }
  }

    .styled-radio-container.styled-radio-container--ou-donation.row{
      .radio-part{
        @media only screen and (min-width: 720px) {
          min-width:200px;
          max-width: 200px;

        }

      }
    }


      .styled-radio--ou-donation.styled-radio label:hover {
            background: #e7f8f4;
      }
    .styled-radio--ou-donation.styled-radio input[type='radio']:checked + label,
    .styled-radio-container--ou-donation.styled-radio-container input[type='radio']:checked + label{
      background: #e7f8f4;
      color: #252e43;
    }


       hr {
    background: none;
    box-shadow: none;
    height: 0;
    border: none;
    border-bottom:none;
  }

  button.ou-donation-btn.btn-flex{
        margin: 0 auto;
    background: #36a38b;
    width: 250px;
    max-width: 100%;
    text-transform: uppercase;
    text-align: center;
    color: white;
    border:none;
    padding: 15px 0px;
    font-weight: 600;
    letter-spacing: 1px;
    -webkit-box-shadow: 0 0 10px #ddd;
    box-shadow: 0 0 10px #ddd;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
  }
}

::v-deep h2{
      color: #36a38b;
    text-transform: capitalize;
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0px;
    margin-bottom: 20px;
}
.form-section {
    margin-bottom: 30px;
    padding: 30px 0px;
    margin: 25px auto;
    border-top: 4px solid #36a38b;

    @media only screen and (min-width: 720px){
    padding: 30px 45px;
    max-width: 1100px;
    background: white;
    -webkit-box-shadow: 0 0 20px rgba(107, 107, 107,0.15);
    box-shadow: 0 0 20px  rgba(107, 107, 107,0.15);
  }

  &.form-section--flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: reverse;
    -ms-flex-flow: column-reverse;
    flex-flow: column-reverse;

        @media only screen and (min-width: 720px){
        }
        @media only screen and (min-width: 940px){
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          -ms-flex-flow: row;
          flex-flow: row;
        }
    }

    .form-section__inner{
      max-width: 700px;
    }
}

.main-donation{
  
}

.thank-text{
  color: #514f4f;
  font-size: 14px;
  font-style: italic;
  text-align: center;
  padding: 0 10px;
  padding-bottom: 125px;
}
</style>

